export const RETRIEVING_MESSAGE_OVERVIEW = 'Retrieving Message Overview';
export const RETRIEVING_MESSAGES = 'Retrieving Messages';
export const DELETING_MESSAGES = 'Deleting Messages';
